<ng-container *transloco="let t">
  <app-child-form
    [submitButtonText]="t('child/editChild')"
    (formSubmit)="editChild($event)"
    [calculatedIdZnev]="child?.calculatedIdZnev"
    [childId]="child?.childId"
  ></app-child-form>
</ng-container>
